import { render, staticRenderFns } from "./SectionParentChecks.vue?vue&type=template&id=00d5adee&scoped=true&"
import script from "./SectionParentChecks.vue?vue&type=script&lang=js&"
export * from "./SectionParentChecks.vue?vue&type=script&lang=js&"
import style0 from "./SectionParentChecks.vue?vue&type=style&index=0&id=00d5adee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d5adee",
  null
  
)

export default component.exports